import { FC } from 'react';
import PortalToTarget from '../PortalToTarget';
import classNames from 'classnames';
import { useEscapeKey } from 'v3/common/hooks/useEscapeKey';

type ModalProps = {
  isOpen: boolean;
  className?: string;
  onClose?: () => void;
  children: JSX.Element;
};

const Modal: FC<ModalProps> = (props) => {
  const { isOpen, className, children, onClose = () => {} } = props;

  const combinedClassName = classNames('main-modal', className, {
    open: isOpen,
  });

  useEscapeKey(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <PortalToTarget className={combinedClassName} allowForWeb>
      <div className="main-modal__content">
        {onClose && (
          <div className="close-btn" onClick={onClose}>
            <i className="fa-regular fa-xmark" />
          </div>
        )}
        {children}
      </div>
    </PortalToTarget>
  );
};

export default Modal;
